module.exports = __webpack_public_path__ + "static/media/insuflaveis@2x.54563904.jpg";